import { data, useLoaderData, useRouteLoaderData } from 'react-router';
import { getNewsletter } from '#app/utils/newsletter.server.ts';
import { type Route } from './+types/newsletter.ts'

export const meta: Route.MetaFunction = () => {
	var title = "JaseOwns.com - Newsletter";
	var description = "JaseOwns.com is the online dumping ground of Jason Ramsey and includes ramblings of an internet ⭐ star. He's a streamer, dreamer, developer, gamer, husband and father who has been a nerd owning people on the internet since dial up 🖥️☎️.  If you're interested in partnering with me, please reach out me.";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "uo,ultima online,self taught,learning,jaseowns,jase,jason"},
		{ property: "og:image", content: "https://jaseowns.com/images/jase.gif"},
		{ property: "og:image:alt", content: "JaseOwns Blinking"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };

export async function loader({ request }: Route.LoaderArgs) {
	const hasSubscribed = await getNewsletter(request) === 'yes';
	return data({
		hasSubscribed,
	})
}

export default function NewsletterRoute() {
	const { hasSubscribed } = useLoaderData<typeof loader>();
	return (
		<main className="container mx-auto font-light text-black dark:text-white">
            <h1 className="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200">
                Newsletter Signup
            </h1>

            <div className="flex flex-col px-10 mb-6">
				{hasSubscribed ? (
					<div className="bg-green-50 p-4 dark:bg-green-500/10 dark:outline dark:outline-green-500/20 mb-26">
						<p>You are already subscribed to the newsletter. Thank you!</p>
					</div>
				) : (
					<p>Join the newsletter below!  I'll send you updates on my projects, tools, and other stuff I'm working on.</p>
				)}
            </div>

		</main>
	)
}

